import { Radio } from '../radio/element';
import { css } from 'lit';
export class Checkbox extends Radio {
    constructor() {
        super(...arguments);
        this.type = 'checkbox';
        this.testId = 'checkbox-input';
    }
}
Checkbox.styles = css `
        :host(:focus-visible),
        input:focus-visible {
            outline: 0;
        }

        :host {
            display: inline-flex;
            cursor: pointer;
            flex-direction: var(--ep-checkbox-flex-direction);
            flex-wrap: var(--ep-checkbox-flex-wrap);
            align-items: var(--ep-checkbox-align-items);
            justify-content: var(--ep-checkbox-justify-content);
            align-content: var(--ep-checkbox-align-content);
        }

        .checkmark {
            position: relative;
            margin-right: var(--ep-checkbox-checkmark-margin-right, 0);
            height: 14px;
            width: 14px;
            background-color: var(--ep-color-white);
            border: var(--ep-checkbox-border, 2px solid var(--ep-color-tertiary));
            border-radius: var(--ep-checkbox-border-radius, 0);
            flex-shrink: 0;
        }

        input {
            display: none;
        }

        input:hover ~ .checkmark,
        .checkmark:hover,
        ep-label:hover ~ .checkmark {
            background-color: var(--ep-color-tertiary);
        }

        input[checked] ~ .checkmark {
            background-color: var(--ep-color-white);
            border-color: var(--ep-color-primary);
        }

        .checkmark:after {
            content: '';
            display: none;
            margin: 1px 0 0 4px;
            width: 4px;
            height: 7px;
            border: solid var(--ep-color-primary);
            border-width: 0 3px 3px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
        }

        :host(.indeterminate) .checkmark {
            border-color: var(--ep-color-primary);
        }

        :host(.indeterminate) .checkmark:after {
            display: block;
            content: '';
            position: absolute;
            transform: rotate(0deg);
            margin: 5px 0 0 3px;
            width: 8px;
            height: 1px;
            border: solid var(--ep-color-primary);
            border-width: 0 0 3px 0;
            -webkit-transform: rotate(0);
            -ms-transform: rotate(0);
        }

        input[checked] ~ .checkmark:after {
            display: block;
            position: absolute;
        }

        input:disabled ~ .checkmark:after {
            background-color: var(--ep-color-gray-3);
            border-color: var(--ep-color-tertiary);
        }

        input:disabled ~ .checkmark {
            border-color: var(--ep-color-tertiary);
            background-color: var(--ep-color-gray-3);
        }

        input:disabled ~ .checkmark,
        input:disabled ~ .checkmark:after,
        input:disabled {
            cursor: not-allowed;
        }
    `;
if (!customElements.get('ep-checkbox')) {
    customElements.define('ep-checkbox', Checkbox);
}
//# sourceMappingURL=element.js.map